<div class="section-container" id="home">
  <img class="section-bg" src="../../../assets/img/hero-img.webp" alt="hero-sction" />

  <div class="descriptions" data-aos="zoom-in-down" data-aos-duration="700">
    <div class="title">{{ "Build your CV" | translate }}</div>
    <div class="details mt-2">
      {{ "We are UP CAREER" | translate }}
    </div>
    <div class="text-center">
      <a href="https://wa.me/+201555842727" target="_blank">
        <button class="gradient-button mt-2 mt-md-3 mt-lg-5">
          {{ "GET IN TOUCH" | translate }}
        </button>
      </a>
    </div>

    <div class="text-center mt-sm-0 mt-md-4 d-none d-sm-block">
      <img class="arrow" src="../../../assets/img/white-arrows.png" />
    </div>
  </div>
  <div class="why-us-box">
    <div class="why-us-content">
      <div class="counters">
        <!-- <div class="counter-box" *ngFor="let item of counters">         
  <div class="counter-wrapper">           
    <h2>{{ item.value | number }}</h2>           
    <span class="plus">+</span> 
    <p class="label"><span class="gradient-text">{{ item.label | translate }}</span></p>        
  </div>
</div> -->
        <div class="counter-box" *ngFor="let item of counters">
          <div class="counter-wrapper">
            <div class="counter-top">
              <h2>{{ formatNumber(item.value) }}</h2>
              <span class="plus">+</span>
            </div>
            <p class="label"><span class="gradient-text">{{ item.label | translate }}</span></p>
          </div>
        </div>


      </div>
    </div>
  </div>

</div>